import React from "react";
import "./Signup.css";
import logo from "./Media/vipps.png";
import inputpng from "./Media/vippsinput.PNG";
import codepng from "./Media/vippscode.PNG";
import commentpng from "./Media/addcomment.PNG";
import FadeIn from "react-fade-in";

import { NavLink } from "react-router-dom";

export class SignupPostConfirm extends React.Component {
  render() {
    const tooYoungHtml = (
      <div>
        <div className="col col-centered summaryCard ">
          <h2>Deltaker under 16</h2>
          <p></p>
          <p>
            {" "}
            Du har registrert en deltaker som er under 16 år. Deltakeren må
            fylle ut et samtykkeskjema med sine foresatte.
            <br />
            Vi vil nekte inngang til alle deltakere under 16 år som ikke har med
            seg utfyllt samtykkeskjema!
            <br />
            Skjemaet finner du her:
            <br />
            <a
              href="http://www.gamerlan.no/__public/samtykkeskjema.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="btn btno btn-info help">Samtykkeskjema</button>
            </a>
          </p>
        </div>
      </div>
    );

    return (
      <FadeIn>
        <div>
          <h2>Takk for at du meldte deg på!</h2>
          <div>
            <div className="vippsbox"> </div>
            <div className="col col-centered summaryCard ">
              <p></p>
              <h5 className="warning">VIKTIG</h5>
              <p className="smallWarning">
                <b>
                  Før du fullfører betaling i Vipps må du fylle inn kode{" "}
                  <span className="whiteFont">({this.props.code})</span> som
                  beskjed/kommentar i Vipps, hvis ikke vet vi ikke hvem du har
                  betalt for!
                </b>
              </p>
              <img className="vippsinput" src={codepng} alt="codepng" />
              <p></p>
            </div>
            <div className="vippsbox"> </div>
            <div className="col col-centered summaryCard ">
              <h2>Betalingsinformasjon</h2>
              <p></p>
              <img className="vippsLogoSmall" src={logo} alt="Logo" />
              <h5>Å betale: {this.props.totalPrice},- </h5>
              <h5>Til nummer: {this.props.vippsnummer} </h5>
              <h5>Kode/Kommentar: {this.props.code} </h5>
              <img className="vippsinput" src={inputpng} alt="inputpng" />
              <p></p>
              <p>
                Søk opp {this.props.vippsnummer}, eller GAMERLAN under
                "Betaling".{" "}
              </p>
              <p>Fyll inn produkter slik at det blir riktig totalpris.</p>{" "}
              <p>Velg "Legg til beskjed" og skriv koden inn som beskjed </p>
              <img className="vippsinput" src={commentpng} alt="commentpng" />
              <p></p>
              <p>
                For at bestillingen din skal være gyldig må innbetaling være
                mottatt innen 3 dager.{" "}
              </p>
              <p></p>
            </div>

            <div className="vippsbox"> </div>

            <div className="col col-centered summaryCard">
              <h2>Bekreftelse</h2>
              <p></p>
              <p>
                Du vil om litt motta en bekreftelsesmail på epost som bekrefter
                din påmelding. Om du ikke mottar en mail innen 10 minutter ber
                vi deg ta kontakt på post@gamerlan.no, eller via våre
                Facebook-sider.{" "}
              </p>
            </div>

            <div className="vippsbox"> </div>
            {this.props.tooYoung === true && (
              <div className="col col-centered summaryCard">{tooYoungHtml}</div>
            )}

            <div className="vippsbox"> </div>

            <NavLink className="NavLink" exact to="/">
              <button className="btn btno btn-warning help">Hjem</button>
            </NavLink>
          </div>
        </div>
      </FadeIn>
    );
  }
}

export default SignupPostConfirm;



// WEBPACK FOOTER //
// ./src/Components/Signup/SignupPostConfirm.js